module.exports = __webpack_public_path__ + "static/img/s21.5f9b51c5.png";